import { Injectable } from '@angular/core';
import { API } from './api.service';
import { ES } from './es.service';
import { AuthService } from './auth-service';
import { CreatePlaylistForm } from '../../../models';

@Injectable()
export class SongsService {
    public mostPlayed= [];
    public mostDownload= [];
    public mostNew= [];
    
    constructor(private api: API, private es: ES, private authService: AuthService) {
    }

    public getMostPlayedSongs(page: number, searchQuery: any = false, sortOrder: any = false,limit:number=20) {
        let queryParams = '?page=' + page+"&limit="+limit;
        if (searchQuery) {
            queryParams += '&q=' + searchQuery;
        }
        if (sortOrder && sortOrder.key) {
            queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        return this.api.get('songs/most-played' + queryParams);
    }

    public getMostDownloadedSongs(page: number, searchQuery: any = false, sortOrder: any = false,limit:number=20) {
        let queryParams = '?page=' + page+"&limit="+limit;
        if (searchQuery) {
            queryParams += '&q=' + searchQuery;
        }
        if (sortOrder && sortOrder.key) {
            queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        return this.api.get('songs/most-downloaded' + queryParams);
    }

    public download(songIds) {

        return this.api.get('songs/downloadable?id=' + songIds);
    }

    public downloadable(songIds) {
        let queryParams = '';
        songIds.forEach(function (arrayItem) {
            queryParams += 'id[]=' + arrayItem + '&';
        });
        return this.api.get('songs?' + songIds);
    }

    public addSongToDiscoveries(song) {
        return this.api.post('api/add-to-discovery', song);
    }

    public removeSongFromDiscoveries(song) {
        return this.api.post('api/remove-from-discovery', song);
    }

    public toggleSongToFavorites(id: string, domainInfo: any) {
        return this.api.post('songs/like', { object: id, domainInfo: domainInfo });
    }

    public createPlaylist(model: CreatePlaylistForm) {
        return this.api.post('playlists/create/', model);
    }

    public getSongsById(songIds, sortOrder: any = false) {
        let queryParams = '';
        if (songIds.length > 0) {
            songIds.forEach(function (arrayItem) {
                queryParams += 'id[]=' + arrayItem + '&';
            });
            if (sortOrder && sortOrder.key) {
                queryParams += 'sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
            }
        }
        return this.api.get('songs?' + queryParams);
    }

    public getAll(page:number=1, sortOrder: any = false,searchTerm='') {
        let queryParams = '';
        queryParams += 'page=' + page;
        if (sortOrder && sortOrder.key) {
            queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        if(searchTerm!=''){
            queryParams += '&name=' + searchTerm
        }
        return this.api.get('songs/newest?' + queryParams);
    }

    public getAllsongsname(name ?:any ,searchSongs ?:any, searchCredits ?:any, searchArtists ?:any, searchPlaylists ?:any, searchCollections ?:any, searchUsers ?:any, searchLike ?:any) {
        let queryParams = '';
        if(name!=''){
            queryParams += '&name=' + name
        }
        if(searchSongs!=''){
            queryParams += '&searchSongs=' + searchSongs
        }
        if(searchCredits!=''){
            queryParams += '&searchCredits=' + searchCredits
        }
        if(searchArtists!=''){
            queryParams += '&searchArtists=' + searchArtists
        }
        if(searchPlaylists!=''){
            queryParams += '&searchPlaylists=' + searchPlaylists
        }
        if(searchCollections!=''){
            queryParams += '&searchCollections=' + searchCollections
        }
        if(searchUsers!=''){
            queryParams += '&searchUsers=' + searchUsers
        }
        if(searchLike!=''){
            queryParams += '&searchLike=' + searchLike
        }

        return this.api.get('songs/songsname?' + queryParams);
    }

    public getSongsfromdb(name ?:any, quickSearch: string = "yes", page:number = 1) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if(name!=''){
            queryParams += '&name=' + name;
            queryParams += '&quickSearch=' + quickSearch;
        }
        return this.api.get('songs/songsfromdb?' + queryParams);
    }

    public getArtistsfromdb(name ?:any, type ?:any, page:number = 1) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if(name!='') {
            queryParams += '&name=' + name + '&type='+ type;
        }
        return this.api.get('songs/artistsfromdb?' + queryParams);
    }

    public getCollectionsfromdb(name ?:any, quickSearch: string = "yes", page:number = 1) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if(name!='') {
            queryParams += '&name=' + name;
            queryParams += '&quickSearch=' + quickSearch;
        }
        return this.api.get('songs/collectionsfromdb?' + queryParams);
    }

    public getPlaylistfromdb(name ?:any, quickSearch: string = "yes", page:number = 1) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if(name != '') {
            queryParams += '&name=' + name;
            queryParams += '&quickSearch=' + quickSearch;
        }
        return this.api.get('songs/playlistsfromdb?' + queryParams);
    }

    public getUsersfromdb(name ?:any, page:number = 1) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if(name!='') {
            queryParams += '&name=' + name
        }
        return this.api.get('songs/usersfromdb?' + queryParams);
    }

    public getSoundsLikefromdb(name ?:any, quickSearch: string = "yes",  page:number = 1) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if(name!='') {
            queryParams += '&name=' + name;
            queryParams += '&quickSearch=' + quickSearch;
        }
        return this.api.get('songs/soundslikefromdb?' + queryParams);
    }

    public getProductioncreditsfromdb(name ?:any) {
        let queryParams = '';
        if(name!=''){
            queryParams += 'q=' + name
        }
        return this.api.get('songs/search-credits-type?' + queryParams);
    }

    public  getSongsfromlblwrtrpblsh(name ?:any , limit ?, page ?:number) {
        let queryParams = '';
         queryParams = '?limit='+limit;
        queryParams += '&page=' + page;

        if(name!=''){
            queryParams += '&name=' + name
        }
        return this.api.get('songs/songsfromlblwrtrpblsh?' + queryParams);
    }

    public getProductioncredits(name ?:any) {
        let queryParams = '';
        if(name!=''){
            queryParams += '&name=' + name
        }
        return this.api.get('songs/productioncredits?' + queryParams);
    }

    public getAllSongs(page:number=1, sortOrder: any = false,name='',type='', islocation:any ) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if (sortOrder && sortOrder.key) {
            queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        if(name!=''){
            queryParams += '&name=' + name;
        }
        if(type!=''){
            queryParams += '&type=' + type;
        }
        queryParams += '&islocation=' + islocation;
        return this.api.get('songs/songss?' + queryParams);
    }

    public getAllSongss(page:number=1, sortOrder: any = false,name='',iswriter:any,ispublisher:any ,islabel:any ) {
        let queryParams = '';
        queryParams += 'page=' + page;
        if (sortOrder && sortOrder.key) {
            queryParams += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        if(name!=''){
            queryParams += '&name=' + name;
        }
        queryParams += '&iswriter=' + iswriter;
        queryParams += '&ispublisher=' + ispublisher;
        queryParams += '&islabel=' + islabel;
        return this.api.get('songs/songsss?' + queryParams);
    }

    public addSongToPlaylist(playlistId: string, songId: string) {
        return this.api.post('playlistsongs/create/', { playlist_id: playlistId, song_id: songId });
    }

    public deleteSongFromPlaylist(playlistId: string, songId: string) {
        return this.api.post('playlistsongs/delete/', { playlist_id: playlistId, song_id: songId });
    }

    public getNewestSongIds(page: any = false, searchQuery: any = null) {
        let options = this.es.setCriteria({
        }, 'song', page, searchQuery);        
        options.body.sort = [{ 'id': { 'order': 'desc' }},{ 'created_on': { 'order': 'desc' }},{ 'quality': { 'order': 'asc' } }];
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return this.es.fetchIds(hits);
        });
    }

    public loadUserMusicCollection(page, searchTerm: any = false, sortOrder: any = false,limit:number=20) {
        let queryString = '?offset=' + page.page+'&limit=' + limit;
        if (searchTerm !== false) {
            queryString += '&q=' + searchTerm;
        }
        if (sortOrder && sortOrder.key) {
            queryString += '&sortBy=' + sortOrder.key + '&sortOrder=' + sortOrder.sortOrder;
        }
        return this.api.get('user/user-likes' + queryString);
    }

    public loadSongsForAdvancedSearch(queryString: string, pageParams: any) {
        let options = this.es.setCriteria({}, 'song', pageParams, queryString);
        return this.es.listing(options).then((body) => {
            let hits = body.hits.hits;
            return this.es.fetchIds(hits);
        });
    }

    public getSongDetailBySlug(slug: string) {
        return this.api.get('songs/by-slug/' + slug);
    }

    public getCall() {
        return this.api.get('songs/call');
    }

    public removeSongFromLibray(id: string) {
        return this.api.post('songs/remove-song-from-library', { object: id });
    }

    public addToMyDownloads(id) {
        return this.api.get('songs/download?id=' + id);
    }

    public prepareDownload(id) {
        return this.api.get('downloads/download?id=' + id);
    }

    public downloadMp3(slug) {
        return this.api.download('downloads/download-file?slug=' + slug);
    }

    public searchCreditsType(searchQuery: any = false) {
        let queryParams = '';
        if (searchQuery) {
            queryParams += '?q=' + searchQuery;
        }
        return this.api.get('songs/search-credits-type' + queryParams);
    }

    public searchCredits(searchQuery: any = false,type: any = false,limit,page:number) {
        let queryParams = '?limit='+limit;
        if (searchQuery) {
            queryParams += '&q=' + searchQuery;
        }
        if (type !== false) {
            queryParams += '&type=' + type;
        }
        queryParams += '&page=' + page;
        return this.api.get('songs/search-credits' + queryParams);
    }

    public adLogging(id) {
        return this.api.get('songs/ad-logging?id=' + id);
    }

    public interactionLogging(params: any) {
        return this.api.post('songs/interaction-logging',params);
    }

    // to check if the songs exists in all songs other than the specific category
    public checkAllSongs(searchTerm: any) {
        let queryParams = '';
        if(searchTerm!=''){
            queryParams += '?name=' + searchTerm
        }
        return this.api.get('songs/check-all-songs' + queryParams);
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/songs-service.ts